import { Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { captureException } from "@sentry/react";
import React, { useState } from "react";
import { PlusCircle, Download } from "react-feather";
import { useDispatch, useSelector } from "react-redux";
import api from "src/utils/api";
import { toastAction } from "../../actions";
import Loader from "../../utils/loader";
import RosterDataModal from "./RosterDataModal";
import moment from "moment";
import { Navigate } from "react-router-dom";

const useStyles = makeStyles({
  root: {},
  table: {
    minWidth: 650
  },
  button: {
    marginBottom: 10
  }
});

export default function RostersList() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const user = useSelector(state => state.user);
  const orgSettings = useSelector(state => state.orgSettings);
  const [index, setIndex] = useState(null);
  const [open, setOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [isLoading, setLoader] = useState(true);
  const [isLoadingDelete, setDeleteLoader] = useState(false);
  const [floorList, setFloorList] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [countData, setCount] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeRowInfo, setActiveRow] = useState({});

  React.useEffect(() => {
    deviceCount();
  }, []);

  const deviceCount = async () => {
    try {
      const res = await api("POST", "rosters/findCount", {}, true);
      setCount(res);
    } catch (error) {}
  };

  React.useEffect(() => {
    fetchData();
  }, [rowsPerPage, page, modalOpen]);

  const fetchData = async () => {
    setLoader(true);

    try {
      const payload = {
        sort: {
          key: "roster.createdAt",
          order: "DESC"
        },
        skip: page * rowsPerPage,
        take: rowsPerPage
      };
      try {
        await deviceCount();
        const rules = await api("POST", "rosters/find", payload, true);
        const res = rules || [];
        setDataList(res);
        setLoader(false);
      } catch (error) {
        captureException(error);
      }
    } catch (error) {
      setLoader(false);
    }
  };

  const handleChangePage = (event, page) => {
    setPage(page);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(event.target.value);
    setPage(0);
  };

  const handleModal = () => {
    setModalOpen(true);
  };

  const handleDevicemodal = id => {
    setIndex(id);
    setModalOpen(true);
  };

  const handleReport = async () => {
    const rosteReportUrl = await api("GET", "rosters/reports", null, true);
    window.open(rosteReportUrl, "_blank");
  };

  if (isLoading) {
    return (
      <React.Fragment>
        <Grid container spacing={3}>
          <Grid item xs={4} />
          <Grid item xs={4}>
            <Loader />
          </Grid>
          <Grid item xs={4} />
        </Grid>
      </React.Fragment>
    );
  }

  if (modalOpen)
    return (
      <RosterDataModal
        open={modalOpen}
        dataList={index !== null ? dataList[index] : null}
        close={() => {
          setIndex(null);
          setModalOpen(false);
        }}
      />
    );

  if (
    user.role === "employee" &&
    (!user.isHod ||
      (
        !orgSettings.rosterManagementAdminEnabled &&
        !orgSettings.individualSupervisorRosteringEnabled
      ) ||
      !orgSettings.rosterManagementEnabled ||
      !orgSettings.rosterManagementEnabledOrg)
  ) {
    debugger;
    return <Navigate to="/404" />;
  }

  return (
    <React.Fragment>
      <Grid
        alignItems="flex-start"
        container
        justify="space-between"
        spacing={3}
        direction="row"
      >
        <Grid item>
          <Typography variant="h4" color="primary">
            Roster Management
          </Typography>
        </Grid>
        <Grid item>
          <Grid container>
            <Grid item>
              <Button
                color="primary"
                className={classes.button}
                startIcon={<Download />}
                variant="outlined"
                onClick={handleReport}
              >
                Download Reports
              </Button>
            </Grid>
            {user.role !== "businessAdmin" && (
              <Grid item>
                <Button
                  color="primary"
                  className={classes.button}
                  startIcon={<PlusCircle />}
                  variant="outlined"
                  onClick={handleModal}
                >
                  New Roster
                </Button>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="center">Sl No</TableCell>
              <TableCell align="center">Name</TableCell>
              <TableCell align="center">Schedule</TableCell>
              <TableCell align="center">From</TableCell>
              <TableCell align="center">To</TableCell>
              <TableCell align="center">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {dataList.map((row, ind) => (
              <TableRow key={ind}>
                <TableCell align="center">
                  {rowsPerPage * page - 1 + ind + 2 || ""}
                </TableCell>
                <TableCell align="center">{row.name || "-"}</TableCell>
                <TableCell align="center">{row.repeat || "-"}</TableCell>
                <TableCell align="center">
                  {moment
                    .utc(new Date(parseInt(row.startDate)))
                    .format("YYYY-MM-DD") || "-"}
                </TableCell>
                <TableCell align="center">
                  {moment
                    .utc(new Date(parseInt(row.endDate)))
                    .format("YYYY-MM-DD") || "-"}
                </TableCell>

                <TableCell align="center">
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => handleDevicemodal(ind)}
                  >
                    View Details
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={countData}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
        page={page}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={[5, 10, 25]}
      />
    </React.Fragment>
  );
}
